import { render, staticRenderFns } from "./CompanyForms.vue?vue&type=template&id=0a12cc37&scoped=true&"
import script from "./CompanyForms.vue?vue&type=script&lang=js&"
export * from "./CompanyForms.vue?vue&type=script&lang=js&"
import style0 from "./CompanyForms.vue?vue&type=style&index=0&id=0a12cc37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12cc37",
  null
  
)

export default component.exports